import { Link } from '@packages/shared';
import type { FC } from 'react';
import { getQuickLinkId } from './getQuickLinkId';

export type BrandListQuickLinksProps = {
  groupNames: string[];
};

/**
 * Quick navigation for brands, usually numbers and letters
 * */
export const BrandListQuickLinks: FC<BrandListQuickLinksProps> = ({ groupNames }) => (
  <div>
    {groupNames.map((name) => (
      <Link
        sx={{
          display: 'inline-block',
          margin: (theme) => theme.spacing(0.55),
          fontSize: (theme) => theme.typography.h5.fontSize,
          '&:not(:hover)': {
            color: (theme) => theme.palette.text.primary,
            textDecorationColor: (theme) => theme.palette.text.primary,
          },
        }}
        href={`#${getQuickLinkId(name)}`}
        key={name}
        underline="always"
      >
        {name}
      </Link>
    ))}
  </div>
);
